import React, {Component} from 'react'
import {NavBar,Tabs,Badge,ListView,Toast} from 'antd-mobile';
import connect from "react-redux/es/connect/connect";
import Shift from '../../../components/historyComponent';
import {pickHistory} from "../../../service/pickService";
import './style.less';
const tabs = [
    { title: <Badge>未完成</Badge> },
    { title: <Badge>已完成</Badge> },
  ];
const dataError = require('../../../common/image/wrongData.png');
const noOrder = require('../../../common/image/noOrder.png');
let pageIndex = 1;
let pageSize = 10;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class PickHistory extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
            type:0,
            shuttleOrderType:0,
            carType:'pickHistory',
        }
    }

    componentDidMount() {
        pageIndex = 1;
       
        var params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                shuttleOrderType:1
            }
        };
       
       this._getOrderList(params);
    }
    pushParam(index){
        this.setState({OrderListData: []});
        pageIndex = 1;
       
        this.setState({
            shuttleOrderType:index == 1 ?  index + 3 : (index == 0 ? 1 :index)
        })
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                shuttleOrderType:index == 1 ?  index + 3 : (index == 0 ? 1 :index)
            }
        };
        this._getOrderList(params);
    }
    _getOrderList(params){
        this.setState({ isLoading:true})
        pickHistory(params).then((res) => {
                if(res.data.code == "0000"){
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        this.setState({isLoading: false,notDataLoading:0});
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else if(res.data.code == "1401"){
                    Toast.info('登录过期，请重新登录',3,this.props.history.push('/login'))
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
                var params={
                    token: this.props.userInfo.token,
                    data:{
                        pageSize: pageSize,
                        pageNum: ++pageIndex,
                        shuttleOrderType:this.state.shuttleOrderType
                    }
                };
           
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading === 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无记录</p>
                    </div>
        }else if(this.state.notDataLoading === 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    goPage(id,type){
        console.log(id)
         this.props.history.push('/progressDetail',{id:id,type:type})
        // this.props.history.push(type === 'poolHistory' ? 'history':'progressDetail',{id:id,type:type})
    }
    render() {
        return (
            <div className="HistoryList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >接驳历史记录</NavBar>
                <Tabs 
                    tabBarActiveTextColor={'#1D1E2C'}
                    tabBarInactiveTextColor={'#69707F'} 
                    tabBarUnderlineStyle={{backgroundColor:'#FF8E1D',border:'1px #FF8E1D solid'}}
                    tabs={tabs}
                    initialPage={0}
                    // onChange={(tab, index) => { this.setState({type:index + 1}) }}
                    onTabClick={(tab, index) => {this.pushParam(index)}}
                >
                <Shift  
                    _getOrderList = {this._getOrderList.bind(this)}
                    notData = {this.notData.bind(this)}
                    _onEndReached = {this._onEndReached.bind(this)}
                    goPage = {this.goPage.bind(this)}
                    {...this.state}
                />
                   
              </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/PickHistory/index.js